export enum PriorityTypeEnums {
  Urgent = 1,
  Order = 2,
  Source = 3,
  Standard = 4,
}
